import { useRequest } from 'features/request/useRequest';
import type { ChapterEnum, PriceListUerRowDataFilterInput } from 'gql/graphql';
import { useAgGridDataSource } from 'hooks/useAgGridDataSource';

import { useEffect, useMemo, useState } from 'react';

import { workOrderPriceListUer } from '../workOrderPriceListUerQueries';

interface IUseUerWorkOrderPriceListUer {
    workOrderObjectId: number;
    chapter: ChapterEnum;
    filterValues?: Record<string, string[]>;
    where?: PriceListUerRowDataFilterInput;
}

const requestId = 'uerWorkOrderPriceListUer';

export const useUerWorkOrderPriceListUer = (props: IUseUerWorkOrderPriceListUer) => {
    const { chapter, workOrderObjectId, where } = props;

    const [allIds, setAllIds] = useState<number[]>([]);

    const variables = useMemo(
        () => ({
            workOrderObjectId,
            chapter,
            where,
        }),
        [chapter, where, workOrderObjectId],
    );

    const [workOrderPriceListUerData, , , workOrderPriceListUerRequest] = useRequest({
        requestId,
        query: workOrderPriceListUer,
        variables,
        withEffect: false,
    });

    const { dataSource, getRowParams } = useAgGridDataSource({
        requestId,
        requestFn: workOrderPriceListUerRequest,
        requestVariables: variables,
    });

    useEffect(() => {
        if (workOrderPriceListUerData?.uerWorkOrderPriceListUer?.items && getRowParams?.current) {
            const items = workOrderPriceListUerData?.uerWorkOrderPriceListUer?.items;

            getRowParams?.current?.successCallback(
                items,
                workOrderPriceListUerData?.uerWorkOrderPriceListUer?.totalCount,
            );

            setAllIds((prevState) => [...prevState, ...items.map((item) => item.id)]);
        }
    }, [
        getRowParams,
        workOrderPriceListUerData?.uerWorkOrderPriceListUer?.items,
        workOrderPriceListUerData?.uerWorkOrderPriceListUer?.totalCount,
    ]);

    return {
        workOrderPriceListUerDataSource: dataSource,
        allIds,
    };
};
